const fairAgroCD = {
  greenColdLight75: "#bfe3dd",
  greenColdLight50: "#7fc8bc",
  greenColdLight25: "#3fac9b",
  greenCold: "#00917A",
  greenColdDark25: "#006c5b",
  greenColdDark50: "#00483d",
  greenColdDark75: "#00241e",
  greenMainLight25: "#dcecd1",
  greenMainLight50: "#b9daa4",
  greenMainLight75: "#96c776",
  greenMain: "#74B549",
  greenMainDark25: "#578736",
  greenMainDark50: "#3a5a24",
  greenMainDark75: "#1d2d12",
  greenWarmLight25: "#e9f0cd",
  greenWarmLight50: "#d3e29b",
  greenWarmLight75: "#bdd469",
  greenWarm: "#A7C637",
  greenWarmDark25: "#7d9429",
  greenWarmDark50: "#53631b",
  greenWarmDark75: "#29310d",
  distinctionLight: "#f26e5f",
  distinctionDark: "#973442",
};

const nfdi4healthColors = {
  secondaryLight75: "#BFE2F1",
  accentLight75: "#E1CFE3",
};

export const theme = {
  color: {
    euiPrimary: fairAgroCD.greenColdDark25,
    euiWarning: fairAgroCD.distinctionLight,
    euiBody: "#E5E5E5",
    euiAccent: fairAgroCD.greenWarm,
    euiPrimaryLight: "#CCE2DE",
    pageBorderTop: fairAgroCD.greenMain,
    infoBadge: fairAgroCD.greenMain,
    infoBadgeGreyed: "#64776a",
    detailBoxTitle: fairAgroCD.greenMain,
    detailBoxTitleLight: fairAgroCD.greenMain,
    actionButton: fairAgroCD.distinctionLight,
    progressBar: fairAgroCD.greenWarm,
    barPlotBar: fairAgroCD.greenMain,
    inputFieldBorder: fairAgroCD.greenMainDark25,
    inputFieldNote: fairAgroCD.greenMainDark25,
    accentPanelTitle: fairAgroCD.greenCold,
    accentPanelBg: "#e1f2df",
    textWarning: "#BD271E",
    textSpecial: "#570E60",
    backgroundWarning: "#F8E9E9",
    backgroundSpecial: nfdi4healthColors.accentLight75,
    backgroundInsertion: nfdi4healthColors.secondaryLight75,
    backgroundDeletion: nfdi4healthColors.accentLight75,
    queryGroupAnd: "#AEE6E6",
    queryGroupOr: "#CD9ED3",
  },
};
